@for (band of bands(); track band.tour.index) {
  <div
    data-testid="timeline-edit-tour"
    [attr.data-first-action-uid]="band.tour.actionUids[0]"
    class="tour-band"
    [class.is-movable]="band.movable"
    [class.is-lifted]="band.tour.actionUids[0] === lifted()"
    [style.left.px]="band.left"
    [style.width.px]="band.width"
    [attr.title]="band.hint"
    (pointerenter)="hovered.set(band.tour.index)"
    (pointerleave)="hovered.set(null)"
    (pointerdown)="onPointerDown(band, $event)">
    <span class="tour-band-tab">{{
      (band.wholeRoute
        ? 'features.plan.edit.tour.band_whole_route'
        : 'features.plan.edit.tour.band'
      ) | translate: { index: band.tour.index, start: band.start, end: band.end }
    }}</span>
  </div>
  @if (hovered() === band.tour.index) {
    <div
      data-testid="timeline-edit-tour-outline"
      class="tour-outline"
      [style.left.px]="band.left"
      [style.width.px]="band.width"></div>
  }
}
